import React, { Component, ReactNode } from 'react';
import RadialProgressBar from './RadialProgressBar';
import ComponentName from '../../../constant/ComponentName';

class CaseRadialProgressContainer extends Component<Props> {
  public render(): ReactNode {
    const { score, header, subHeader, maxScore, progressColor, labelColor, loading } = this.props;

    return (
      <div
        style={{ zIndex: 0, boxShadow: '2px 2px 15px 0px #0000000D' }}
        data-testid={`chart_radial_${header}_container`}
        className={'flex flex-col items-center gap-y-2 justify-center h-full w-full rounded-[8px] bg-white px-3 py-3'}
      >
        <div className={'flex flex-col w-full items-center justify-center relative group cursor-pointer'}>
          <p className={'2xl text-f-black-2'} data-testid={`chart_radial_${header}_header`}>
            {header}
          </p>
          <p className={'text-xs text-center overflow-hidden text-f-black-3 truncate max-w-full'} data-testid={`chart_radial_${header}_sub_header_container`}>
            {subHeader}
          </p>
          <div
            style={{ zIndex: 1 }}
            className={'absolute top-[-50px] rounded-[8px] min-w-[250px] items-center -left-6 group-hover:flex hidden w-full py-3 px-3 bg-black text-white'}
            data-testid={`chart_radial_${header}_sub_header`}
          >
            {subHeader}
          </div>
        </div>
        <RadialProgressBar
          loading={loading}
          score={score}
          maxScore={maxScore}
          progressColor={progressColor}
          labelColor={labelColor}
          data-testid={`chart_radial_${header}_value`}
        />
      </div>
    );
  }
}

interface Props {
  header: string;
  subHeader: string;
  score: number;
  maxScore: number;
  progressColor: string;
  labelColor: string;
  loading?: boolean;
}

export default CaseRadialProgressContainer;
